import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["priceEdit", "price", "modal"];

  modal() {
    this.modalTarget.setAttribute("x-data", "{ open: true }");
  }
}
